import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import PlotInfo from './PlotInfo';
import BuildingInfo from './BuildingInfo';
import UnitTypes from './UnitsTypes'
import Box from '@material-ui/core/Box';
import useFormStyles from '../../common/FormStyle';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import Grow from '@material-ui/core/Grow';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { GoToPlootoButton } from '../common/GoToPlootoButton'
import { useDispatch, useSelector } from 'react-redux';
import {
  SET_PROJECT_NAME,
  SET_ACTIVE_TAB
} from '../../../redux/actions/actionTypes';

const useStyles = makeStyles((heme) => ({
  root: {
    minHeight: "100vh",
  }
}))

// Form section 1 component
function FormBuildingInfo(props) {
  const { handleNext, total_building_width, plot_width, corridor_width } = props;
  const dispatch = useDispatch()
  const buildingInfoState = useSelector(state => state.globalFormData.buildingInfo);

  const styles = useStyles();
  const formStyles = useFormStyles();

  // If the building type is I, and the building width is larger than the plot depth/width, display an error
  const [showError, setShowError] = useState(false);

  return (
    <Box paddingX={2} paddingY={2} className={styles.root}
      display="flex" flexDirection="column">
      {/* Form name */}
      <Typography variant="h5" className={formStyles.bold}>Project Name</Typography>
      <TextField
        color="primary"
        placeholder="Enter a project name"
        size="small"
        variant="outlined"
        name="project_name"
        id="project_name_form"
        fullWidth
        value={buildingInfoState.project_name}
        onChange={(event) => {
          dispatch({
            type: SET_PROJECT_NAME,
            payload: event.target.value
          })
        }}

      />

      <Box paddingY={2}>
        <PlotInfo plot_width_show_error={showError} />
        <BuildingInfo total_building_width_show_error={showError} />
        <UnitTypes />
      </Box>

      <Snackbar open={showError} TransitionComponent={Grow}>
        <Alert severity="error" elevation={6} variant="filled">
          Total building width can not exceed plot width for the chosen building type.
                </Alert>
      </Snackbar>

      <GoToPlootoButton />

      <Box marginY={1}>
        <Button
          variant="contained"
          endIcon={<NavigateNextIcon />}
          fullWidth
          onClick={(event) => {
            dispatch({
              type: SET_ACTIVE_TAB,
              payload: 1
            })
          }}>
          Next
        </Button>
      </Box>
    </Box>
  )
}

export default FormBuildingInfo